import React, { Component } from "react";
import { Header, Segment } from "semantic-ui-react";

class HelpLinks extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h2">
          <a
            href="https://launchpad.37signals.com/signin"
            target="_blank"
            rel="noopener noreferrer"
          >
            BUMP Basecamp Login
          </a>
          <Header.Subheader>
          BUMP's resources platform that houses documents to help you manage and execute your program, 
          contains software release notes, and lets you network with other BUMP partners
          </Header.Subheader>
        </Header>
        <Header as="h2">
          <a
            href="https://login.netbanx.com/office/"
            target="_blank"
            rel="noopener noreferrer"
          >
            NetBanx (Paysafe)
          </a>
          <Header.Subheader>
            Our preferred credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
        <Header as="h2">
          <a
            href="https://gateway.itstgate.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            BridgePay
          </a>
          <Header.Subheader>
            Our previous credit card processor. You may login here to manage
            your credit card payments.
          </Header.Subheader>
        </Header>
      </Segment>
    );
  }
}

export default HelpLinks;
